import TableHeaderCell from 'emerald-ui/lib/TableHeaderCell';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: TableHeaderCell, componentName: 'TableHeaderCell' }], 'TableHeaderCell'),
  description: 'A header cell with sorting properties.',
  codeSamples: [
    {
      title: 'Default',
      scope: { TableHeaderCell },
      code: `<div style={{ display: 'inline-block' }}>
  <table className="eui-table">
    <thead>
      <tr>
        <TableHeaderCell>Header</TableHeaderCell>
      </tr>
    </thead>
  </table>
</div>`,
    },
  ],
};
